import webkit_line_clamp from 'webkit-line-clamp';

export default class AnchorBlock {
   
    /**
     * 
     * @param {String} el Element to search for (querySelector)
     * @param {Boolean} line_clamp Whether we should clamp the number of lines
     * @param {Number} line_number Number of limes to clamp to.
     */
    constructor(el, line_clamp = true, line_number = 3) {
        if(line_clamp) {
            document.querySelectorAll(el).forEach(curr_el => {
                webkit_line_clamp(curr_el, line_number);
            })
        }
        let max_height = this.get_max_height(el);
        this.set_height(el, max_height);
    }

    /**
     * Gets the maximum height for a given element.
     * @param {String} el Element to search for (querySelector)
     * @returns {Number} The maximum height of the given element. 
     */
    get_max_height(el) {
        let max_height = 0;

        document.querySelectorAll(el).forEach(curr_el => {
           if(curr_el.offsetHeight > max_height) {
               max_height = curr_el.offsetHeight;
           } 
        });

        return max_height
    }

    /**
     * Setting each of a given element to a specified height
     * @param {String} el Element to search for (querySelector) 
     * @param {Number} height Height to set element to.
     */
    set_height(el, height) {
        document.querySelectorAll(el).forEach(curr_el => {
            curr_el.style.height = height + "px";
        })
    }
}